import { render, staticRenderFns } from "./AccountQrCodeConnector.vue?vue&type=template&id=38987a8f&scoped=true"
import script from "./AccountQrCodeConnector.vue?vue&type=script&lang=js"
export * from "./AccountQrCodeConnector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38987a8f",
  null
  
)

export default component.exports